import React from 'react';
import { Page } from '../Page';
import { Beef, Leaf, Milk } from 'lucide-react';
const seaProteins = [{
  name: 'Salmon',
  img: 'https://cdn.magicpatterns.com/uploads/7tSyAhvGY3jp4Lk1sASC4Y/1.png'
}, {
  name: 'Tuna',
  img: 'https://cdn.magicpatterns.com/uploads/dKgxchhHgEkx8MDhf5axwV/2.png'
}, {
  name: 'Halibut',
  img: 'https://cdn.magicpatterns.com/uploads/iaYW6pyVPoiZZCq8WuvQut/3.png'
}, {
  name: 'Shrimp',
  img: 'https://cdn.magicpatterns.com/uploads/nNNyBVtiNNkbeBwJdWbHZo/4.png'
}, {
  name: 'Crab',
  img: 'https://cdn.magicpatterns.com/uploads/snr7C9q4emdrWn6mXqpxkr/5.png'
}];
const landProteins = [{
  name: 'Chicken Breast',
  img: 'https://cdn.magicpatterns.com/uploads/uyUcpm2TEUtfj76LGBJDps/7.png'
}, {
  name: 'Turkey/Ground',
  img: 'https://cdn.magicpatterns.com/uploads/8Jy2j9wVbMUPrvevKq73aA/6.png'
}, {
  name: 'Eggs',
  img: 'https://cdn.magicpatterns.com/uploads/68Ld573hKnRG1fNq4E5akd/8.png'
}, {
  name: 'Bison',
  img: 'https://cdn.magicpatterns.com/uploads/1J4Kzg9SfYHVmir2rUKn9f/9.png'
}, {
  name: '90/10 Ground Beef',
  img: 'https://cdn.magicpatterns.com/uploads/9dMavTJCCdMyZ9vauci1ar/10.png'
}];
const earthProteins = [{
  name: 'Tofu',
  img: 'https://cdn.magicpatterns.com/uploads/kX8bvqkN39AU7hKi8NdDQV/1.png'
}, {
  name: 'Lentils',
  img: 'https://cdn.magicpatterns.com/uploads/4SLPv34Pg2mTjqVnd5iHcJ/2.png'
}, {
  name: 'Chickpeas',
  img: 'https://cdn.magicpatterns.com/uploads/dRVkhurRZZ3WuDiMnw2Zdx/3.png'
}, {
  name: 'Pea Protein',
  img: 'https://cdn.magicpatterns.com/uploads/mHumJF8GF7w4ENVn6Pu281/4.png'
}, {
  name: 'Edamame',
  img: 'https://cdn.magicpatterns.com/uploads/uPzhMp6Tt5VtABszK134eN/5.png'
}];
function ProteinRow({
  title,
  icon,
  items
}: {
  title: string;
  icon?: React.ReactNode;
  items: {
    name: string;
    img: string;
  }[];
}) {
  return <div className="border border-[#D8D8D0] bg-[#EAEAE4] overflow-hidden" data-id="element-475">
      <div className="bg-navyslate px-3 py-2 flex items-center gap-2" data-id="element-476">
        {icon}
        <h2 className="text-xs font-serif text-white" data-id="element-477">{title}</h2>
      </div>
      <div className="p-3" data-id="element-478">
        <div className="flex justify-between items-center" data-id="element-479">
          {items.map((item, i) => <div key={i} className="flex flex-col items-center gap-1" data-id="element-480">
              <div className="w-20 h-14 flex items-center justify-center" data-id="element-481">
                <img src={item.img} alt={item.name} className="max-w-full max-h-full object-contain" data-id="element-482" />
              </div>
              <span className="text-[10px] font-medium text-[#3B3B3B] text-center" data-id="element-483">
                {item.name}
              </span>
            </div>)}
        </div>
      </div>
    </div>;
}
export function Page4() {
  return <Page pageNumber={11} variant="light" data-id="element-484">
      <div className="flex flex-col h-full" data-id="element-485">
        <div className="mb-6 pt-4" data-id="element-486">
          <p className="text-[10px] font-bold text-tealslate uppercase tracking-[0.2em] mb-3" data-id="element-487">
            The Essentials
          </p>
          <h1 className="text-4xl font-serif text-[#1F1F1F] leading-tight mb-3" data-id="element-488">
            Choosing <span className="text-tealslate" data-id="element-489">Lean Proteins</span>
          </h1>
          <p className="text-sm text-[#3B3B3B] leading-[1.8] max-w-lg" data-id="element-490">
            Choosing lean proteins helps reduce calories, promote heart health,
            and reduce the risk of GLP-1 side effects like nausea and vomiting.
          </p>
        </div>

        <div className="space-y-3 flex-1" data-id="element-491">
          <ProteinRow title="From The Sea" items={seaProteins} data-id="element-492" />
          <ProteinRow title="From The Land" icon={<Beef className="w-4 h-4 text-lightteal" data-id="element-494" />} items={landProteins} data-id="element-493" />
          <ProteinRow title="From The Earth" icon={<Leaf className="w-4 h-4 text-lightteal" data-id="element-496" />} items={earthProteins} data-id="element-495" />

          <div className="border border-[#D8D8D0] bg-[#EAEAE4] overflow-hidden" data-id="element-497">
            <div className="bg-navyslate px-3 py-2 flex items-center gap-2" data-id="element-498">
              <Milk className="w-4 h-4 text-lightteal" data-id="element-499" />
              <h2 className="text-xs font-serif text-white" data-id="element-500">From The Cow</h2>
            </div>
            <div className="p-3" data-id="element-501">
              <div className="flex flex-wrap gap-2" data-id="element-502">
                {['Low Fat Milk', 'Low Fat Cottage Cheese', 'Low Fat Yogurt', 'Whey Protein'].map((item, i) => <div key={i} className="bg-bluegray/40 px-3 py-1.5 text-[11px] text-white font-medium border border-[#D8D8D0]" data-id="element-503">
                    {item}
                  </div>)}
              </div>
            </div>
          </div>
        </div>
      </div>
    </Page>;
}